(function() {
  window.abilityService = {
    get(data) {
      return axios.get(`/api/ability/get.php`);
    },
    save(data) {
      return axios.post('/api/ability/save.php', data);
    }
  }
})();